import React from 'react';
import { Link } from 'react-router-dom';
import t from 'prop-types';
import { FormattedMessage } from 'react-intl';

import alertIcon from '../../../../assets/icons/alert-icon-outline.svg';

import styles from './AccountDetails.scss';

const UnknownEmailPlaceholder = () => (
  <FormattedMessage
    id="profile.accountDetails.unknownEmail"
    defaultMessage="Unknown Email"
    description="Placeholder, for when don’t know user’s email, i.e. signed up via social network"
  />
);


const AccountDetails = ({ profile, onLogOut }) => {
  const { is_email_set: isEmailSet, email_verified: isVerified, email_can_be_verified: isEmailCanBeVerified } = profile;

  const isVerifyEmailShown = isEmailSet && !isVerified && isEmailCanBeVerified;

  return (
    <section className={styles.wrapper}>
      <h3 className={styles.header}>
        <FormattedMessage
          id="profile.accountDetails.title"
          defaultMessage="Account Details"
          description="Title of the profile section containing general user’s info, like name, pic, email"
        />

        <span>
          {profile.is_password_set && (
            <Link className={styles.changePassword} to="/enter/password/change">
              <FormattedMessage
                id="profile.accountDetails.changePasswordLink"
                defaultMessage="Change Password"
                description="Link to the page for changing password"
              />
            </Link>
          )}
        </span>
      </h3>

      <div className={styles.section}>

        <div className={styles.nameBlock}>

          <div className={styles.middleBlock}>
            <div className={styles.emailWrapper} key="email">
              <span className={styles.name}>{isEmailSet ? profile.email : (<UnknownEmailPlaceholder />)}</span>
              <span className={styles.nameFullView}>{isEmailSet ? profile.email : (<UnknownEmailPlaceholder />)}</span>
            </div>

            { isVerifyEmailShown && (
              <div className={styles.confirmEmail}>
                <img src={alertIcon}  width="16" height="16" alt="Exclamation sign icon" />
                <a href="/enter/email/send-verify">
                  <FormattedMessage
                    id="profile.confirmEmailBanner"
                    defaultMessage="Confirm your email"
                    description="Banner shown to users with unverified emails"
                  />
                </a>
              </div>
            )}
          </div>

          <button className={styles.logout} onClick={onLogOut}>
            <FormattedMessage
              id="profile.accountDetails.logOut"
              defaultMessage="Log out"
              description="Log out button, user will be dropped back to the login page"
            />
          </button>
        </div>

      </div>
    </section>
  );
};

AccountDetails.propTypes = {
  profile: t.shape({
    is_password_set: t.bool.isRequired,
    email_can_be_verified: t.bool,
    picture: t.string,
    full_name: t.string,
    email: t.string.isRequired,
    type: t.string,
    state: t.string,
    email_verified: t.bool,
    is_email_set: t.bool,
    subscription: t.shape({
      hasActiveSubscription: t.bool.isRequired,
      subscriptionCancellable: t.bool,
      name: t.string,
      expiration_date: t.string
    })
  }),
  onLogOut: t.func.isRequired
};

export default AccountDetails;
